import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	className: "alert-circle",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n            .alert-circle-a,.alert-circle-b,.alert-circle-c{stroke:#ffffff;;stroke-width:1.5px;}\n            .alert-circle-a,.alert-circle-b{stroke-linecap:round;}\n            .alert-circle-a{stroke-linejoin:round;}\n            .alert-circle-b,.alert-circle-c{stroke-miterlimit:10;z-index:99}\n            .alert-circle-c{fill:#FF9D0B }\n        " }) }),
		/* @__PURE__ */ _jsx("circle", {
			className: "alert-circle-c",
			cx: 12,
			cy: 12,
			r: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "alert-circle-a",
			d: "M12,16.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,16.5h0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "alert-circle-b",
			x1: 12,
			y1: 13.5,
			x2: 12,
			y2: 5.25
		})
	]
});
const ForwardRef = forwardRef(SvgAlertCircle);
export default ForwardRef;
